import $ from './el.JsModules.js';

elabs.Popovers = class {
  'use strict';

  constructor() {
    this.TIME_BETWEEN_POPOVERS = 2000; // note there is an additional 3 second day before showing each popover caused by transition delay (to allow preloading)

    const shouldShowNewsletterPopover = this.shouldShowNewsletterPopover();
    this.currentPopoverIndex = shouldShowNewsletterPopover ? -1 : 0; // skip newsletter popover template if user has already subscribed

    this.handleNewsletterUrlHash();

    window.addEventListener("hashchange", () => {
        console.log('Hash changed:', window.location.hash);
        this.handleNewsletterUrlHash();
    })

    requestTimeout(() => { 
      this.showNextPopover();
    }, 5000); // Let the page load for a moment before showing any popover
  }

  handleNewsletterUrlHash = () => {
    if (window.location.hash !== '#show-newsletter-popup') {
      return; // No action needed if the hash is not set
    }

    //Unset localstorage
    localStorage.setItem('el-customer-has-subscribed-to-newsletter', 'false');
    localStorage.setItem('el-customer-last-shown-newsletter-overlay-timestamp', '');

    //Remove hash from url
    history.replaceState(null, '', window.location.pathname + window.location.search);

    const newsletter = $('.el-popover__newsletter-signup-button');

    if (newsletter) {
      const popoverParent = newsletter.parents('.el-popover').first();
      if (popoverParent.length > 0 && popoverParent.hasClass('el-popover--visible')) { 
        console.log('Newsletter popover is already visible');
        return; // Newsletter popover is already visible, no need to show it again
      }
    }

    this.currentPopoverIndex = -1; // Reset the index to show the newsletter popover first

    this.showNewsletterPopoverInstant = true;
    this.showNextPopover();
    this.showNewsletterPopoverInstant = false; // Reset the flag after showing the popover
  }

  showNextPopover = () => {
    this.currentPopoverIndex++;
    let nextPopover = $('.el-popover-template').eq(this.currentPopoverIndex);
    if (nextPopover.length === 0) {
      return; // no more left to show
    }
    nextPopover = $(nextPopover.html());

    // Check if this popover has already been seen
    const hash = elabs.Utils.hashCode(nextPopover.find('.el-popover__content-inner').text());
    if (localStorage.getItem('el-popover-seen--' + hash) === 'true' && this.showNewsletterPopoverInstant !== true) {
      this.showNextPopover();
      return;
    }

    elabs.bodyElement.append(nextPopover);

    if (this.shouldShowNewsletterPopover() && this.currentPopoverIndex === 0) {
      this.initialiseNewsletterPopover();
    }

    requestTimeout(() => {
      nextPopover.addClass('el-popover--visible');
    }, 1);

    $('.el-popover__close-button').click(() => {
      if (this.shouldShowNewsletterPopover() && this.currentPopoverIndex === 0) {
        localStorage.setItem('el-customer-last-shown-newsletter-overlay-timestamp', new Date().getTime());
      } else {
        const hash = elabs.Utils.hashCode(nextPopover.find('.el-popover__content-inner').text());
        localStorage.setItem('el-popover-seen--' + hash, 'true'); // This will make sure it is not shown again
      }

      nextPopover.removeClass('el-popover--visible').addClass('el-popover--dismissed');
      requestTimeout(() => {
        this.showNextPopover();
      }, this.TIME_BETWEEN_POPOVERS);
    });
  };

  initialiseNewsletterPopover = () => {
    $('.el-popover__newsletter-signup-button').click(async () => {
      const emailAddress = $('.el-popover input[type="email"]').first().val();

      if (!emailAddress || !emailAddress.trim()) {
        alert('Please enter an email address');
        return;
      }

      try {
        const result = await elabs.newsletterService.signupNewsletter(emailAddress.trim(), 'popover');
        if (result.success) {
          elabs.newsletterService.handleSuccess();
          elabs.Utils.showToast('Thanks for subscribing to our newsletter!');
          $('.el-popover__close-button').click(); // Close the popover
        } else {
          elabs.Utils.showToast('There was a problem with subscribing you to the newsletter. Please try again.');
        }
      } catch (error) {
        elabs.Utils.showToast('There was a problem with subscribing you to the newsletter. Please try again.');
      }
    });
  };

  shouldShowNewsletterPopover = () => {

    if (this.showNewsletterPopoverInstant) {
      return true; // Show the newsletter popover immediately if the URL hash is set
    }

    if (Shopify.designMode) {
      return; // Do not show when in the theme editor- it's annoying!
    }

    if (window.customer.accepts_marketing) {
      return false; // They are already subscribed, don't annoy them
    }

    const customerHasSubscribed = localStorage.getItem('el-customer-has-subscribed-to-newsletter') === 'true';
    if (customerHasSubscribed) {
      return false;
    }

    let lastShownNewsletterOverlayDate = localStorage.getItem('el-customer-last-shown-newsletter-overlay-timestamp');
    if (lastShownNewsletterOverlayDate) {
      lastShownNewsletterOverlayDate = parseInt(lastShownNewsletterOverlayDate);
      lastShownNewsletterOverlayDate = new Date(lastShownNewsletterOverlayDate);

      const now = new Date().getTime();
      // const seventyTwoHoursAfterLastShownNewsletterOverlay = lastShownNewsletterOverlayDate.getTime() + 20 * 1000; // 20 seconds (for testing)
      const seventyTwoHoursAfterLastShownNewsletterOverlay =
        lastShownNewsletterOverlayDate.getTime() + 72 * 60 * 60 * 1000; // 72 hours between showing the newsletter overlay again

      if (now < seventyTwoHoursAfterLastShownNewsletterOverlay) {
        return false; // We do not want to show the overlay for now
      }
    }

    return true;
  };
};

// Initialise all Popovers
elabs.onJavascriptReady(function () {
  new elabs.Popovers();
});
